export default __webpack_public_path__ + "./assets/img/cierre-minas.png";